// disable the first option in select

class DisableFirstOption {
  constructor() {
    this.init();
  }

  init() {
    const fui_select = document.querySelector('[data-disable-first-option=""]');
    if (fui_select) {
      fui_select.options[0].setAttribute('disabled', 'disabled');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new DisableFirstOption());
